/**
 * Logout + redirect helpers (uses Redux logout).
 */

import { logout } from "./authSlice";
import { broadcastLogout } from "./crossTabAuthSync";
import { resetCoinPopupGate } from "./onboardingGateUtils";
import appRouter from "./globalRouter";
import { stopTaraSpeech } from "./taraSpeechSynthesis";
export { getStoredToken, hasValidSession, isTokenExpired } from "./authTokenUtils";

/**
 * Clear Redux + storage and send user to login (RTK, idle timeout, guards).
 */
export function clearSessionAndRedirectToLogin(dispatch, options = {}) {
  const { replace = true, hardRedirect = false } = options;

  try {
    localStorage.removeItem("coinSummary");
    sessionStorage.removeItem("coinSummary");
  } catch {
    // ignore storage errors
  }

  resetCoinPopupGate();

  document.body.classList.remove(
    "terms-onboarding-active",
    "coin-onboarding-active",
    "health-interests-onboarding-active",
    "has-global-tara-panel"
  );
  document.getElementById("terms-modal-backdrop")?.remove();
  stopTaraSpeech();

  dispatch(logout());
  broadcastLogout();

  if (hardRedirect) {
    globalThis.location.replace("/login");
    return;
  }

  appRouter.navigate("/login", { replace });
}
